import { Box } from '@capitalise/ui-design-system';
import { FC } from 'react';

interface SearchClientTitleProps {
  title: string;
  subTitle: string;
  clientsCount: number;
}

const SearchClientTitle: FC<SearchClientTitleProps> = ({
  title,
  subTitle,
  clientsCount,
}: SearchClientTitleProps) => {
  return (
    <Box marginTop="large" display="flex" flexDirection="column" mb="3xsmall">
      <Box
        typography="body-16"
        color="grey-800"
        display="flex"
        justifyContent="space-between"
        alightItems="center"
      >
        <Box typography="heading-16" fontWeight={500} color='grey-900'>
          {title}
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          backgroundColor="grey-50"
          width="xsmall"
          height="xsmall"
          borderRadius="50%"
          typography="caption-12"
          fontWeight={700}
        >
          {clientsCount}
        </Box>
      </Box>
      <Box typography="body-14" color="grey-500">
        {subTitle}
      </Box>
    </Box>
  );
};

export default SearchClientTitle;
